import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrl } from '../../boot/index.js';


export const getDms = createAsyncThunk("/get-dms-list", async (data) => {
    // const token = localStorage.getItem("authToken")
    // try {
    //     const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/get-dms-list`, data, {
    //         headers: {
    //             "auth-token": token,
    //         }
    //     },);
    //     // console.log("dmsresponse",response)
    //     return response;
    // } catch (error) {
    //     console.error('Error fetching Vendor - ', error);
    //     throw error;
    // }
})

export const getDmsType = createAsyncThunk('/get-net-metering-by-id',
    async (id) => {
        const token = localStorage.getItem('authToken');
      
        // console.log("id", id)
        try {
            const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/get-net-metering-list/${id}`,
                
                {
                    headers: {
                        'auth-token': token,
                    },
                }
            );
            // console.log("rrrrrrrrrrrrrrrrrrr",response)

            return response; // Return only the data part of the response
        } catch (error) {
            console.error('Error fetching DMS - ', error);
            throw error;
        }
    }
);

export const getLeadDmsType = createAsyncThunk('/get-net-metering-by-id',
    async (id) => {
        const token = localStorage.getItem('authToken');
      
        // console.log("id", id)
        try {
            const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/get-lead-net-metering-list/${id}`,
                
                {
                    headers: {
                        'auth-token': token,
                    },
                }
            );
            // console.log("rrrrrrrrrrrrrrrrrrr",response)

            return response; // Return only the data part of the response
        } catch (error) {
            console.error('Error fetching DMS - ', error);
            throw error;
        }
    }
);

//get kyc
export const getKyc = createAsyncThunk("/get-list", async (id) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/get-list/${id}`, {
            headers: {
                "auth-token": token,
            }
        },);
        // console.log("kyclistg",response)
        return response;
    } catch (error) {
        console.error('Error fetching Kyc - ', error);
        throw error;
    }
})

//get kyc
export const getLeadKyc = createAsyncThunk("/get-list", async (id) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/get-lead-list/${id}`, {
            headers: {
                "auth-token": token,
            }
        },);
        // console.log("kyclistg",response)
        return response;
    } catch (error) {
        console.error('Error fetching Kyc - ', error);
        throw error;
    }
})


export const getNastionalPortel = createAsyncThunk("nationalPortal/fetch", async (id) => {
    const token = localStorage.getItem("authToken");
    // console.log("iddd", id)
   
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/getlist-nationalPortal/${id}`, {
            headers: {
                "auth-token": token,
            }
        });
        // console.log("national", response)
        return response.data;
    } catch (error) {
        console.error("Error fetching National Portal - ", error);
        throw error;
    }
});

export const getLeadsNastionalPortel = createAsyncThunk("nationalPortal/fetch", async (id) => {
    const token = localStorage.getItem("authToken");
    // console.log("iddd", id)
   
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/getlist-lead-nationalPortal/${id}`, {
            headers: {
                "auth-token": token,
            }
        });
        // console.log("national", response)
        return response.data;
    } catch (error) {
        console.error("Error fetching National Portal - ", error);
        throw error;
    }
});

//subsidy
export const getSubsidy = createAsyncThunk("/get-subsidy", async (id) => {
    const token = localStorage.getItem("authToken")
   
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/get-subsidy-list/${id}`, {
            headers: {
                "auth-token": token,
            }
        },);
        // console.log("subsidyresponse", response)
        return response;
    } catch (error) {
        console.error('Error fetching Vendor - ', error);
        throw error;
    }
})

//subsidy
export const getLeadSubsidy = createAsyncThunk("/get-subsidy", async (id) => {
    const token = localStorage.getItem("authToken")
   
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/get-lead-subsidy-list/${id}`, {
            headers: {
                "auth-token": token,
            }
        },);
        // console.log("subsidyresponse", response)
        return response;
    } catch (error) {
        console.error('Error fetching Vendor - ', error);
        throw error;
    }
})



export const getDmsStatus = createAsyncThunk("/getlist-dmsStatus", async (id) => {
    const token = localStorage.getItem("authToken")
   
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/getlist-dmsStatus/${id}`, {
            headers: {
                "auth-token": token,
            }
        },);
        // console.log("dmsStatus", response)
        return response;
    } catch (error) {
        console.error('Error fetching Vendor - ', error);
        throw error;
    }
})


export const getLeadDmsStatus = createAsyncThunk("/getlist-dmsStatus", async (id) => {
    const token = localStorage.getItem("authToken")
   
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/getlist-lead-dmsStatus/${id}`, {
            headers: {
                "auth-token": token,
            }
        },);
        // console.log("dmsStatus", response)
        return response;
    } catch (error) {
        console.error('Error fetching Vendor - ', error);
        throw error;
    }
})



// get Company 
export const getDmsStatusAll = createAsyncThunk("/get-all-dmsStatus", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/get-all-dmsStatus`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching Companies - ', error);
        throw error;
    }
})